import { Api } from './Api'

class DirectDebitConsent {
  post (socialId, clearingNumber, bankAccount, ocr, bankIdLogId, signal) {
    const body = {
      soc_id: socialId.trim(),
      clearing_number: clearingNumber.trim(),
      bank_account: bankAccount.trim(),
      bankid_log_id: bankIdLogId
    }
    return fetch(`${Api.getBaseUrl()}directdebitconsent/${ocr}`, Api.getOptions('POST', body, signal))
  }

  get (ocr, signal) {
    return fetch(`${Api.getBaseUrl()}directdebitconsent/${ocr}`, Api.getOptions('GET', {}, signal))
  }
}

export default DirectDebitConsent
